import { useParams } from 'next/navigation';
import Button from 'components/gruenland/atoms/button/Button';
import { CheckoutButtonProps } from './types';

const CheckoutButton: React.FC<CheckoutButtonProps> = ({ className, disabled, text, onClick }) => {
  const { locale } = useParams();

  return (
    <div className={className}>
      {/* Native <a> instead of NextLink: ShippyPro's PUDO map widget cannot
          reinitialize in a SPA. A full page reload on checkout entry guarantees
          a clean DOM for the script every time. */}
      <a href={`/${locale}/checkout`}>
        <Button disabled={disabled} onClick={onClick} variant="buttonSecondaryNegative" className="w-full">
          {text}
        </Button>
      </a>
    </div>
  );
};

export default CheckoutButton;
